// extracted by mini-css-extract-plugin
export default {"wrapper":"Appointments_wrapper__SVUne","filter":"Appointments_filter__n7Zft"};